import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
// 导入加载api和路由对象
import loader from './common/loadApisAndRouters.js'
// 组件模块
import Login from './views/Login.vue'
// 二楼库位布局
import StorageSecond from './views/modules/storageLocation/second.vue'
// 三楼库位布局
import StorageThird from './views/modules/storageLocation/third.vue'
// 全自动库位布局
import StorageAuto from './views/modules/storageLocation/auto.vue'

/* 此部分代码是用来消除 Uncaught (in promise) NavigationDuplicated{_name: "NavigationDuplicated...错误的 */
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
/************************************************************/

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Home.vue'),
      children: loader.loadRouters()
    },
    {
      path: '/storage/second',
      name: 'storage_second',
      component: StorageSecond
    },
    {
      path: '/storage/third',
      name: 'storage_third',
      component: StorageThird
    },
    {
      path: '/storage/auto',
      name: 'storage_auto',
      component: StorageAuto
    }
  ]
})
export default router
